import * as Yup from 'yup'
import ValidationCache from '../../utils/validationCache';
import { OptionType } from '../../types/constants';
import { LoadTelematico } from '../../types/types';
import { Agency } from '../../models/agency';

const validationCache = new ValidationCache('default', 60000);

const setCacheName = (newName: string) => {
    validationCache.setName(newName)
}
const clearCache = () => {
    validationCache.clear()
}
const reformatQuery = (query: string) => {
    let q = query.replace(/[_]/g, '[_]').replace(/[*]/g, '%')
    if(q.endsWith('$')) {
        console.log('query finisce per $')
        q = q.replace(/[$]$/, '')
    } else if(!q.endsWith('%')) {
        q += '%'
    }
    q = q.replace(/%/g, '%25').replace(/[ ]/g, '%20').replace(/#/g, '%23')
    return q
}

// const dateFns = new DateFnsUtils({locale: it})
// const isExpired = (pwexp: DateTimeISO) => {
//     return dateFns.date(pwexp).getTime() < Date.now()
// }

// const isAcceptable = (ubo: Principal, filters: UsersFilterType) => {
//     return !(
//         (filters.pwExpireFilter && ((filters.noPwExpire && isExpired(ubo.pwExpire)) || (!filters.noPwExpire && !isExpired(ubo.pwExpire)))) ||
//         (filters.lockedFilter && ((!filters.onlyLocked && ubo.isLocked) || (filters.onlyLocked && !ubo.isLocked)))
//     )
// }

const newLoadTelematico = (companyId: number, agencyId: number, year: number): LoadTelematico => {
    const newFilter: LoadTelematico = {
        companyId: companyId,
        agencyId: agencyId,
        agency: null,
        telematicoType: '',
        year: year,
        cfImpresa: '',
        yearCf1: year,
        cfCollab1: '',
        yearCf2: year,
        cfCollab2: '',
        yearS3: year,
        cfSocio3: '',
        isConvenienza: null
    }
    return newFilter as LoadTelematico;
}

export class TelematicoServiceValidation {
    levels: OptionType[];
    // ownerContext: string;
    // checkOwnerContextErrorMessage: string;

    // checkOwnerContext = (value: string) => {
    //     value = value || ''
    //     console.log(`checkOwnerContext ${value}`)
    //     return (value.startsWith(this.ownerContext))
    // }

    constructor(adLevels: OptionType[]) {
        // console.log(`UserServiceValidation.ctor ${adRole}`)
        this.levels = adLevels;
        // this.ownerContext = adOwnerContext
        // this.checkOwnerContextErrorMessage = `L'owner deve iniziare per ${this.ownerContext}`
    }

    telematicoForfetariFormSchemaBase = () => {
        // const ownerContext = this.ownerContext;
        return Yup.object().shape({
            companyId: Yup.number().label('Company').required('La company è obbligatorio'),
            agencyId: Yup.number().label('Studio').required('Lo studio è obbligatorio'),
            telematicoType: Yup.string().label('Tipo telematico').required('Il tipo telematico è obbligatorio'),
            year: Yup.number().label('Anno').nullable(),
            cfImpresa: Yup.string().label('Codice fiscale impresa').nullable(),
            yearCf1: Yup.number().label('Anno collaboratore 1').nullable(),
            cfCollab1: Yup.string().label('Collab 1').nullable(),
            yearCf2: Yup.number().label('Anno collaboratore 2').nullable(),
            cfCollab2: Yup.string().label('Collab 2').nullable(),
        })
    }
    
    telematicoConvenienzaFormSchemaBase = () => {
        // const ownerContext = this.ownerContext;
        return Yup.object().shape({
            companyId: Yup.number().label('Company').required('La company è obbligatorio'),
            agencyId: Yup.number().label('Studio').required('Lo studio è obbligatorio'),
            telematicoType: Yup.string().label('Tipo telematico').required('Il tipo telematico è obbligatorio'),
            year: Yup.number().label('Anno impresa').nullable(),
            cfImpresa: Yup.string().label('Codice fiscale impresa').nullable(),
            yearCf1: Yup.number().label('Anno socio 1').nullable(),
            cfCollab1: Yup.string().label('Socio 1').nullable(),
            yearCf2: Yup.number().label('Anno socio 2').nullable(),
            cfCollab2: Yup.string().label('Socio 2').nullable(),
            yearS3: Yup.number().label('Anno socio 3').nullable(),
            cfSocio3: Yup.string().label('Socio 3').nullable(),
        })
    }
    
}

export default {
    newLoadTelematico,
    setCacheName,
    clearCache,
    reformatQuery,
}